const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return '';
  const startCharacter = phoneNumber.length > 10 ? 1 : 0;

  const areaCode = phoneNumber.substr(startCharacter, 3);
  const prefixNumber = phoneNumber.substr(startCharacter + 3, 3);
  const lineNumber = phoneNumber.substr(startCharacter + 6, 4);
  return `(${areaCode}) ${prefixNumber}-${lineNumber}`;
};

export default formatPhoneNumber;
